<div class="d-flex flex-column mx-2">
	<div class="d-flex">
		<div class="display-6 ms-1 mt-2 mb-1">Check Search</div>
		<div class="ms-auto">
			<p-button pRipple styleClass="p-button-raised p-button-secondary m-2" (click)="onReturn()">
				<ng-template pTemplate="content">
					<div class="d-flex justify-content-center">
						<fa-icon [icon]="['far', 'magnifying-glass']" size="lg" class="ms-1 me-2"></fa-icon>
						Search
					</div>
				</ng-template>
			</p-button>
		</div>
	</div>
	<p-divider></p-divider>

	<div class="d-flex flex-column ms-2">
		<div class="d-flex">
			<div class="display-12">Date type:</div>
			<div class="d-flex ms-auto display-14">
				<div class="field-radiobutton mx-3">
					<p-radioButton inputId="dateTypeSingle" name="dateTypeSelect" value="single" [(ngModel)]="dateType"></p-radioButton>
					<label for="dateTypeSingle">Selected Date</label>
				</div>
				<div class="field-radiobutton mx-3">
					<p-radioButton inputId="dateTypeSingle" name="dateTypeSelect" value="range" [(ngModel)]="dateType"></p-radioButton>
					<label for="city1">Date Range</label>
				</div>
			</div>
		</div>

		<div class="p-grid mt-4">
			<div class="p-col-12 p-md-4 display-12">
				<span class="my-auto"> Business Date </span>
			</div>
			<div class="p-col-12 p-md-8" *ngIf="dateType === 'single'">
				<span class="p-float-label w-100">
					<p-calendar
						#startDateInput
						[(ngModel)]="searchCriteria.businessDate"
						inputStyleClass="text-right"
						appendTo="body"
						styleClass="w-100"
					></p-calendar>
					<label for="startDateInput">Business Date</label>
				</span>
			</div>
			<div class="p-col-12 p-md-4 d-flex" *ngIf="dateType === 'range'">
				<span class="p-float-label w-100">
					<p-calendar #startDateInput [(ngModel)]="searchCriteria.start" inputStyleClass="text-right" appendTo="body" styleClass="w-100"></p-calendar>
					<label for="startDateInput">Start</label>
				</span>
			</div>
			<div class="p-col-12 p-md-4" *ngIf="dateType === 'range'">
				<span class="p-float-label w-100">
					<p-calendar
						#endDateInput
						[(ngModel)]="searchCriteria.end"
						inputStyleClass="text-right"
						appendTo="body"
						placeholder="End Date"
						styleClass="w-100"
					></p-calendar>
					<label for="endDateInput">End</label>
				</span>
			</div>
		</div>

		<div class="p-grid">
			<div class="p-col-12 p-md-4 display-12">CC Acct #</div>
			<div class="p-col-12 p-md-8">
				<span class="p-float-label w-100">
					<p-inputNumber
						#ccAccountNumber
						[(ngModel)]="searchCriteria.account"
						maxlength="4"
						inputStyleClass="text-right"
						styleClass="w-100"
						class="w-100"
						[useGrouping]="false"
					></p-inputNumber>
					<label for="ccAccountNumber">CC Account Number</label>
				</span>
			</div>
		</div>
	</div>
</div>
